import React from "react";
import { connect } from "react-redux";
import _ from "underscore";
import axios from "axios";
import { addViewClaims, isRecentBatch, readyAllClick } from "../upload/actions";
import { addQueudedClaims } from "~/app/submit_claims/claims_table/actions";
import { bindActionCreators } from "redux";
import { mapDbClaimsToTableRow,kinetik_api_url,wrapObject, b64toBlob } from "~/app/utilities";
import toastr from "toastr";
import MDSpinner from "react-md-spinner";
import JSZip from 'jszip'
import { LoadingOverlay, Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

var FileSaver = require('file-saver');

class TableToolbar extends React.Component {
  constructor(props){
    super(props)
    this.state={
      showSpinner: false,
      showExportSpinner : false
    }
  }

  render() {
   
    return (
      <div>
        <input
          className="search-bar"
          type="text"
          placeholder="Search"
          onChange={event => this.onInputChange(event.target.value)}
        />
        {/* <span className="table-claim-num">Number of Claims: {this.props.numClaims}</span> */}

        <button
          type="button"
          onClick={() => this.exportClaims()}
          className="btn btn-primary export-btn left"
        >
          Export
        </button>

        {/* <button
          type="button"
          onClick={() => this.exportEDI()}
          className="btn btn-primary export-btn left"
        >
          Export EDI
        </button> */}
        {this.state.showExportSpinner&&<MDSpinner className="margin-left"/>} 

        <span className="upload-cnt">{this.props.view_claims.length + " Claims Uploaded"}</span>
        

        <button
          type="button"
          onClick={this.submitClaims}
          className="btn btn-primary submit-btn right"
        >
          {(this.props.renderedLocation==="batch_status")?"Re-Submit Claims": "Submit Claims"}
        </button>
        {/* {this.state.showSpinner&&<MDSpinner className="right"/>} */}
        <Loader fullPage loading={this.state.showSpinner} />

        <button
          type="button"
          onClick={() => this.readyAll()}
          className="btn btn-primary ready-btn right"
        >
          Prepare All
        </button>
        
      </div>
    );
  }

  exportClaims = () => {
    let queuedClaims = this.props.queued_claims;
    let promise = Promise.resolve();
    var zip = new JSZip();
    let claim = {};
    if (_.isEmpty(queuedClaims)) {
      toastr.error("No claims selected for export!")
    }
    else {
      this.setState({ showExportSpinner: true })
      _.each(queuedClaims, (key, val) => {
        promise = promise.then(() => {
          if (key === true) {
            let URL = kinetik_api_url + '/generate1500/' + val;
            return axios.get(URL)
              .then((response) => {
                if (response.data.success) {
                  const base64Data = response.data.data[0] 
                  claim = response.data.data[1]
                  const blob = b64toBlob(base64Data)
                  zip.file(claim.patient.pat_name_l + "," + claim.patient.pat_name_f+ ".pdf", blob);
              
                }
                else {
                  toastr.error("Claim " + val + " failed to export!")
                  return -1;
                }
              })
          }
        })
      })
      promise.then(() => {
        zip.generateAsync({
          type: "blob", compression: "DEFLATE"
        })
          .then((content) => {
            this.setState({ showExportSpinner: false })
            FileSaver.saveAs(content, claim.batch.file_name.slice(0, -4) + ".zip")
          });
      })
    }
  }

  exportEDI = () => {
    let queuedClaims = this.props.queued_claims;
    var ediClaims = [];
    _.each(queuedClaims, (key, val) => {
      if (key === true) {
        ediClaims.push(val)
      }
    })
    console.log("edi CLaims", ediClaims)
    let URL = kinetik_api_url + '/edi/837Medicaid';

    axios.post(URL, ediClaims).then((response) => {
      console.log(response)
    })

  }






  onInputChange(term) {
    this.props.onSearchTermChange(term);
  }
  readyAll=()=>{
    this.props.readyAllClick(true);
  }

  submitClaims = async () => {

    let allClaims = this.props.view_claims;
    allClaims = _.flatten(allClaims);
    let queuedClaims = this.props.queued_claims;
    
    //Check if claims were prepared to submit
    if (queuedClaims.length === 0) {
      toastr.warning("No claims were selected for submission!")
      return -1;
    }

    this.setState({ showSpinner: true })
    let selClaims = [];
    _.each(queuedClaims, (val, key) => {
      if (val) selClaims.push(key);
    });
    const readyClaims = _.filter(allClaims, claim => {
      return _.contains(selClaims, claim.remote_claimid);
    });
    const removedNulls = nullFieldsRemover(readyClaims);

    
    const token = localStorage.getItem('authToken');
    const submitBatchURL = kinetik_api_url+ "/submit/batch"
    return axios
      .post(submitBatchURL, { claims: removedNulls,token })
      .then(response => {
        console.log("claim submit response",response)
        const errorFromClaimMd = response.data.message.result;
        if (errorFromClaimMd !== undefined) {
          this.setState({ showSpinner: false })
          toastr.error(errorFromClaimMd.error._attributes.error_mesg);
        } else {
         
          toastr.success(response.data.message);
          this.updateBatchStatus().then(() => { // updating all the status updates from claim md
            let claim_ids = []
            const claimsSubmitted = wrapObject(response.data.parsedResponse.claim)
            _.each(claimsSubmitted, claim => {
              claim_ids.push(claim._attributes.claimid);
            })
            this.getAllClaimDataFromDB(claim_ids); //getting the claims data to render on the table
          });

        }
      })
      .catch(error => {
        this.setState({ showSpinner: false })
        console.log("Submit claims error", error);
        toastr.error("Error submitting claims");
      });
  };
  updateBatchStatus =async () => {
   // this.setState({showSpinner:true})
   const token = localStorage.getItem('authToken');

    var requestURL = kinetik_api_url + "/batch/update?token="+token;
    return axios
      .get(requestURL)
      .then(response => {
        this.setState({showSpinner:false})
        toastr.success(response.data.message)
      })
      .catch(err => {
        this.setState({showSpinner:false})
        toastr.error(err)
      });
  }

   

  getAllClaimDataFromDB = (claim_ids) => {
    const token = localStorage.getItem('authToken');
    axios
      .post(kinetik_api_url + "/batch/claims", {
        claim_ids: claim_ids,token
      })
      .then(response => {
        const mappedData = _.map(response.data, mapDbClaimsToTableRow);
        const errorIndexes = []
        _.each(mappedData, claim => {  // to remove "ins_" errors 
          if (claim.error !== null) {
            _.each(claim.error, (error, index) => {
              if (error._attributes.fields.includes("ins")) {
                errorIndexes.push(index);
              }
            })
            _.each(errorIndexes, index => {
              claim.error.splice(index, 1);
            })
          }
        })

        this.props.addViewClaims(mappedData);
        this.props.isRecentBatch(false);
        this.readyAll()

      })
      .catch(err => {
        console.log("/batch/claims error:", err);
      });
  }
}

const mapStateToProps = state => {
  return {
    queued_claims: state.submitClaims.queued_claims,
    uploaded_claims: state.submitClaims.uploaded_claims,
    view_claims: state.submitClaims.view_claims,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewClaims,isRecentBatch,readyAllClick,addQueudedClaims
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(TableToolbar);


const nullFieldsRemover=(readyClaims)=>{
 return _.map(readyClaims,claim=>{
   return _.omit(claim,(val,key,object)=>{
      return val===null;
    })
  })
}




// WEBPACK FOOTER //
// ./src/app/submit_claims/claims_table/TableToolbar.js